import { useState, useEffect } from "react";

interface PublicSettings {
	appName: string;
	aiBotName: string;
}

export function usePublicSettings() {
	const [settings, setSettings] = useState<PublicSettings>({ appName: "CRM", aiBotName: "AI BOT" });
	const [loaded, setLoaded] = useState(false);

	useEffect(() => {
		fetch("/api/settings/public")
			.then((res) => {
				if (!res.ok) throw new Error("Failed to load settings");
				return res.json() as Promise<PublicSettings>;
			})
			.then((data) => {
				setSettings(data);
				setLoaded(true);
			})
			.catch(() => {
				setLoaded(true);
			});
	}, []);

	return { ...settings, loaded };
}
